import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import siteNavigation from "./nav-config";
import useAuth from "./auth/useAuth";
import GoogleLoginButton from "./auth/googleLoginButton";

const Sidebar = () => {
    const [errorMessage, setErrorMessage] = useState("");
    const [isSidebarVisible, setSidebarVisible] = useState(window.innerWidth > 768);

    const { isAuthenticated, login, logout, loading } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();;

    const { googleLogin } = useAuth();
    // console.log('googleLogin imp', googleLogin);

    const isActive = (item) => {
        const currentPath = location.pathname + location.hash;
        return currentPath === item.href;
    };

    useEffect(() => {
        const updateSidebarVisibility = () => {
            setSidebarVisible(window.innerWidth > 768);
        };

        updateSidebarVisibility();
        window.addEventListener("resize", updateSidebarVisibility);

        return () => window.removeEventListener("resize", updateSidebarVisibility);
    }, []); 

    const toggleSidebar = () => setSidebarVisible(!isSidebarVisible);

    const closeSidebar = () => {
        if (window.innerWidth <= 768) {
            setSidebarVisible(false);
        }
    };

    const handleGoogleLoginSuccess = async (credentialResponse) => {
        try {
            console.log("Credential response received from Google login:", credentialResponse);
    
            if (!credentialResponse || !credentialResponse.credential) {
                throw new Error("Invalid credential response from Google login.");
            }
    
            const credentialToken = credentialResponse.credential;
            const response = await googleLogin(credentialToken);
            console.log("Google Login Response:", response);
    
            if (!response || !response.tokens || !response.tokens.jwtToken || !response.user) {
                throw new Error("Invalid response from googleLogin.");
            }
    
            const { jwtToken } = response.tokens;
            const { displayName } = response.user;
    
            login(jwtToken, displayName);
            navigate("/profile");
        } catch (error) {
            setErrorMessage("Google login failed. Please try again.");
            console.error("Google login error:", error);
        }
    };
    

    const sidebarStyle = {
        display: isSidebarVisible ? "block" : "none",
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        overflowY: "auto",
        zIndex: 1000,
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <>
            <div className="sidebar-toggle" onClick={toggleSidebar}>☰ Menu</div>
            <div className="sidebar" style={sidebarStyle}>
                <div className="logo-container">
                    <Link to={siteNavigation.logo.href} onClick={closeSidebar}>
                        <img src={siteNavigation.logo.src} alt={siteNavigation.logo.alt} className="logo" />
                    </Link>
                </div>
                <hr className="custom-line" />

                {siteNavigation.menuItems
                    .filter((item) => !item.requiresLogin || isAuthenticated)
                    .map((item, index) => (
                <Link
                    key={index}
                    to={item.href}
                    className={isActive(item) ? "active" : ""}
                    onClick={closeSidebar}
                >
                    <span className="menu-item">
                        {item.icon && <span className="menu-icon">{item.icon}</span>}
                        <span className="menu-title">{item.title}</span>
                    </span>
                </Link>

                    ))}

              
                <hr className="custom-line" />

                {!isAuthenticated ? (
                    <>
                        <div id="login-form-container">
                            <div style={{ width: "160px", margin: "0 auto" }}>
                                <GoogleLoginButton handleSuccess={handleGoogleLoginSuccess} />
                            </div>
                            {errorMessage && (
                                <div className="error-message" style={{ marginTop: "10px", textAlign: "center" }}>
                                    {errorMessage}
                                </div>
                            )}
                        </div>
                        <br />
                        <br />
                    </>
                ) : (
                    <>
                        <div id="login-form-container">
                        <button className="login-button" type="button" onClick={logout}>
                            Logout
                        </button>
                        </div>
                        <br></br>
                        <br></br>
                        <br></br>
                    </>
                )}
            </div>
        </>
    );
};

export default Sidebar;





